import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Loader2, Flame } from "lucide-react";
import { PACKS, startCheckout } from "../lib/packs";

export const Guarantee = ({ compact = false }) => (
  <div className={`rounded-2xl bg-emerald-50 border border-emerald-200 flex items-start gap-3 ${compact ? "p-3" : "p-4"}`} data-testid="guarantee-copy">
    <ShieldCheck size={compact ? 18 : 22} className="text-emerald-600 shrink-0 mt-0.5" />
    <div>
      <div className={`font-bold text-emerald-800 ${compact ? "text-sm" : ""}`}>Money-back guarantee</div>
      <p className={`text-emerald-700 mt-0.5 ${compact ? "text-xs" : "text-sm"}`}>Try your pack risk-free. If it doesn't move your game, we'll refund you, no questions asked.</p>
    </div>
  </div>
);

export const PackButtons = ({ compact = false, testPrefix = "pack" }) => {
  const [busy, setBusy] = useState("");
  const buy = async (lookup) => {
    setBusy(lookup);
    try { await startCheckout(lookup); } catch (e) { toast.error("Could not start checkout"); setBusy(""); }
  };
  return (
    <div className="space-y-3">
      {PACKS.map((p) => (
        <button key={p.lookup} data-testid={`${testPrefix}-${p.lookup}`} disabled={!!busy} onClick={() => buy(p.lookup)}
          className={`relative w-full text-left rounded-3xl border-2 transition active:scale-[0.99] ${compact ? "p-4" : "p-5"} ${
            p.popular ? "border-royal bg-gradient-to-br from-royal/5 to-turq/5" : "border-slate-200 bg-white"}`}>
          {p.popular && <span className="absolute -top-3 left-5 bg-royal text-white text-[11px] font-bold px-3 py-1 rounded-full">BEST VALUE</span>}
          <div className="flex items-center justify-between">
            <div>
              <div className={`font-serif font-bold text-navy ${compact ? "text-xl" : "text-2xl"}`}>{p.sessions} sessions</div>
              <div className="text-sm text-slate-500">{p.per} per session</div>
            </div>
            <div className="text-right">
              <div className={`font-bold text-navy ${compact ? "text-xl" : "text-2xl"}`}>{p.price}</div>
              {busy === p.lookup && <Loader2 size={18} className="animate-spin text-royal ml-auto mt-1" />}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

// Bottom sheet shown after a session when the athlete is nearly out of credits.
export const UpsellSheet = ({ credits, streak, onClose }) => (
  <div className="absolute inset-0 z-50 bg-black/60 flex items-end" data-testid="upsell-sheet">
    <div className="w-full bg-white text-navy rounded-t-3xl p-6 pb-[max(1.5rem,env(safe-area-inset-bottom))] animate-fade-up max-h-[92%] overflow-y-auto mm-scroll">
      <div className="w-10 h-1 bg-slate-200 rounded-full mx-auto mb-5" />
      <div className="inline-flex items-center gap-1.5 bg-orange-50 border border-orange-200 text-orange-600 rounded-full px-3 py-1 text-xs font-bold">
        <Flame size={13} className="fill-orange-500 text-orange-500" /> {streak > 0 ? `${streak} day streak` : "Momentum matters"}
      </div>
      <h3 className="font-serif text-2xl font-bold mt-3 leading-tight">Keep the streak going</h3>
      <p className="text-slate-500 text-sm mt-1.5" data-testid="upsell-credits-line">
        {credits === 0 ? "That was your last session. " : `You have ${credits} session left. `}
        Lock in your next personalized visualizations, replays stay free forever.
      </p>
      <div className="mt-5"><PackButtons compact testPrefix="upsell-pack" /></div>
      <div className="mt-4"><Guarantee compact /></div>
      <button data-testid="upsell-dismiss-btn" onClick={onClose} className="w-full mt-3 text-slate-400 text-sm py-2">Not now</button>
    </div>
  </div>
);

export default UpsellSheet;
